const replaceSubmit = () => {
    const $buttons = document.querySelectorAll('.fui-btn.fui-submit')
    if (!$buttons.length) return

    const btnHtml = `
        <button type="submit" class="btn group btn-cta --green" data-submit-action="submit" style="margin:var(--fui-btn-margin)">
            <span class="btn-text">
                <div></div>
            </span>
            <span class="icon icon-outline-arrow-right-square btn-icon primary-icon">
		        <svg><use xlink:href="#outline/arrow-right-square"></use></svg>
	        </span>
        </button>
    `

    $buttons.forEach($el => {
        $el.insertAdjacentHTML('afterend', btnHtml)
        $el.nextElementSibling.querySelector('.btn-text > div').innerHTML = $el.textContent
        $el.remove()
    })
}

document.addEventListener('DOMContentLoaded', replaceSubmit)
